import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, tap } from 'rxjs/operators';

import { SearchService } from 'src/app/services';
import { GetSearchCategories } from './search.actions';
import { of } from 'rxjs';
import { MenuItem, Menu } from 'src/app/interfaces';

interface SearchStateModel {
    categories: MenuItem[];
    imageCategories: MenuItem[];
}

@State<SearchStateModel>({
    name: 'search',
    defaults: {
        categories: [],
        imageCategories: []
    }
})
@Injectable()
export class SearchState {
    constructor(private service: SearchService) {}

    @Selector()
    static categories(state: SearchStateModel) {
        return state.categories;
    }
    @Selector()
    static imageCategories(state: SearchStateModel) {
        return state.imageCategories;
    }

    @Action(GetSearchCategories)
    getAll(ctx: StateContext<SearchStateModel>) {
        return this.service.getMenu().pipe(
            catchError((err) =>
                of<Menu>({
                    categories: [],
                    imageCategories: []
                })
            ),
            tap((response) => {
                ctx.patchState({
                    categories: response.categories,
                    imageCategories: response.imageCategories
                });
            })
        );
    }
}
